import { CSSProperties, useEffect, useMemo, useRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const containerStyle: CSSProperties = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

interface GridCheckboxComponentProps extends ICellRendererParams {
    onChange?: (checked: boolean, data: any) => boolean;
    readonly?: boolean;
    style?: CSSProperties;
    hide?: boolean;
    dataId?: string;
}

export const GridCheckboxView = ({ value, onChange, data, readonly, style, hide, dataId }: GridCheckboxComponentProps) => {
    const inputRef = useRef<HTMLInputElement>();

    const checkboxStyle = useMemo(() => {
        return {
            cursor: readonly ? 'initial' : 'pointer',
            padding: 5
        };
    }, []);

    const handleOnChange = (e) => {
        if (onChange) {
            const proceedWithEvent = onChange(e.target.checked, data);
            if (!proceedWithEvent) {
                e?.preventDefault();
                e.target.checked = false;
            }
        }
        e.stopPropagation();
        e.originalEvent?.stopPropagation();
    };

    useEffect(() => {
        const currentValue = inputRef.current?.checked;
        // validate current value is not null or undefined and is not equal to current value
        if (currentValue !== undefined && currentValue !== null && value !== currentValue) {
            inputRef.current.checked = value;
        }
    }, [value]);

    if (hide) {
        return null;
    }

    return (
        <div style={containerStyle} data-test-id={dataId}>
            <input
                style={{ ...checkboxStyle, ...style }}
                ref={inputRef}
                type="checkbox"
                onChange={handleOnChange}
                defaultChecked={value}
                disabled={readonly}
            />
        </div>
    );
};
